module.exports = "<div class=\"point-details-wrapper\">\n     {{selectedPoint}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/point-details/point-details.component.html
// module id = ../../../../../src/app/point-details/point-details.component.html
// module chunks = main